import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function YoutubeIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.282 12.353L10.64 15.96C10.574 16.004 10.495 16.027 10.417 16.027C10.348 16.027 10.28 16.01 10.217 15.975C10.084 15.902 10 15.762 10 15.609V8.392C10 8.239 10.084 8.098 10.217 8.025C10.35 7.952 10.513 7.958 10.642 8.041L16.282 11.648C16.402 11.726 16.473 11.859 16.473 12C16.473 12.143 16.402 12.276 16.282 12.353ZM18.717 5H5.281C3.469 5 2 6.469 2 8.282V15.717C2 17.531 3.47 19 5.283 19H18.719C20.531 19 22 17.532 22 15.719V8.284C22 6.478 20.523 5 18.717 5Z",
    fill: "currentColor"
  }));
}